import React from "react"
import { useInViewEffect } from "react-hook-inview"
import ModalTechStore from "./ModalTechStore"
import { useEffect, useState } from "react"

const HomeMarketplace = (props) => {
  const { router, openOnload } = props
  const [isOpen, setIsOpen] = useState(false)
  const [hasOpened, setHasOpened] = useState(false)

  useEffect(() => {
    if (isOpen === false && hasOpened === true) {
      setHasOpened(false)
      return
    }

    // modal opens, update uri
    if (isOpen === true && hasOpened === false) {
      if (isOpen === true) setHasOpened(true)
      document.querySelector(".nav-header").classList.remove("pinned")

      const route = "/home/technical/gemz"
      router.push(route, undefined, { shallow: true })
    }
  }, [isOpen])

  useEffect(() => {
    if (openOnload === false) return
    const uri = router.query?.hscene
    if (uri === undefined || uri.length !== 2 || uri[1] !== "gemz") return

    setIsOpen(true)
  }, [openOnload, router.query])

  const ref = useInViewEffect(
    ([entry], observer) => {
      const lastY = observer.lastY || -1
      const newY = entry.boundingClientRect.y
      const pFactions = document.querySelector(".p-factions")

      // once we leave, perform an action
      if (entry.isIntersecting === false) {
        if (newY > lastY) {
          // console.log("emporium onLeave - scrolling up")
          pFactions.classList.remove("hidden")
        }
      } else {
        // console.log("emporium onEnter")
        pFactions.classList.add("hidden")
        document.querySelector(".p-opensea").classList.remove("trigger-photo")
      }

      observer.lastY = newY
    },
    { threshold: 0.5 }
  )

  return (
    <div
      data-scroll-section
      ref={ref}
      className="p-emporium relative py-16 md:py-48"
      style={{
        backgroundImage:
          "url(/bg-details--gradient.png), url(/bg-details--pattern.webp)",
        backgroundPosition: "left top",
        backgroundRepeat: "repeat-x, repeat",
      }}
    >
      <div
        className="absolute left-0 top-1 h-full w-1"
        data-scroll
        data-scroll-repeat
        data-scroll-call="sceneChange"
        attr-scene="marketplace"
        id="scene-marketplace"
      />
      <div
        id="s-emporium"
        className="w-full flex-col items-center justify-start px-4 text-[#FEFCF9] md:flex md:px-0"
      >
        <div className="block text-center">
          <h2
            data-scroll
            // data-scroll-delay="0.6"
            // data-scroll-speed="2"
            className="
              c-lerp-block_title
              text-title 
              relative
              pb-10
              font-display"
          >
            <span
              className="inline-block"
              data-scroll
              data-scroll-speed="4"
              data-scroll-delay="0.13"
            >
              M
            </span>
            <span
              className="inline-block"
              data-scroll
              data-scroll-speed="4"
              data-scroll-delay="0.12"
            >
              a
            </span>
            <span
              className="inline-block"
              data-scroll
              data-scroll-speed="4"
              data-scroll-delay="0.11"
            >
              g
            </span>
            <span
              className="inline-block"
              data-scroll
              data-scroll-speed="4"
              data-scroll-delay="0.10"
            >
              i
            </span>
            <span
              className="inline-block"
              data-scroll
              data-scroll-speed="4"
              data-scroll-delay="0.09"
            >
              c
            </span>
            &nbsp;
            <span
              className="inline-block"
              data-scroll
              data-scroll-speed="4"
              data-scroll-delay="0.09"
            >
              Marketplace
            </span>
          </h2>
          <p
            data-scroll
            data-scroll-speed="4"
            className="
              text-summary
              relative 
              mx-auto
              block
              max-w-[1700px]
              
              font-sans
              opacity-70
              md:w-[42%]"
          >
            Magic Folk holders will have access to the Magic&nbsp;Marketplace.
            Holders can exchange $GEMZ for a range of items and pets, Allowlist
            spots, holder-exclusive tools, or even coal.
          </p>
          <ModalTechStore isOpen={isOpen} setIsOpen={setIsOpen} />
          <h6
            data-scroll
            data-scroll-speed="4"
            onClick={() => setIsOpen(true)}
            className="tech-label mt-4 mb-6 cursor-pointer rounded-xl py-2 pr-4 pl-3 font-bold opacity-70 hover:opacity-100"
            style={{
              transform: "scale(0.8) translate3d(-12%,0,0)",
              transition: "opacity 350ms",
            }}
          >
            <svg
              className="relative -top-[2px] inline-block h-6 w-8"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.5126 10.6574L22.1253 9.93899C21.8989 9.08778 21.5593 8.27101 21.1163 7.50344L22.2927 5.30899C22.4354 5.03838 22.3862 4.7038 22.1696 4.48731L20.5059 2.82425C20.2894 2.60775 19.9546 2.55855 19.6839 2.70124L17.4985 3.88703C16.7306 3.4442 15.9184 3.1047 15.062 2.87837L14.3433 0.492029C14.2547 0.196812 13.984 0 13.6788 0H11.326C11.0208 0 10.7501 0.201732 10.6615 0.492029L9.94287 2.87837C9.0864 3.1047 8.27424 3.4442 7.50637 3.88703L5.31107 2.71108C5.04034 2.56839 4.71056 2.61267 4.49398 2.83409L2.83027 4.49223C2.61369 4.70872 2.56447 5.0433 2.70722 5.31391L3.88855 7.50344C3.44555 8.27101 3.10592 9.08286 2.87949 9.93899L0.492221 10.6574C0.196888 10.7459 0 11.0165 0 11.3216V13.6735C0 13.9785 0.201811 14.2492 0.492221 14.3377L2.87949 15.0561C3.10592 15.9073 3.44555 16.7241 3.88855 17.4916L2.71214 19.6861C2.56939 19.9567 2.61862 20.2913 2.83519 20.5078L4.4989 22.1708C4.71548 22.3873 5.05019 22.4365 5.31599 22.2938L7.51129 21.1179C8.27916 21.5607 9.09132 21.9002 9.94779 22.1265L10.6664 24.508C10.755 24.8032 11.0258 25 11.3309 25H13.6837C13.9889 25 14.2596 24.7983 14.3482 24.508L15.0669 22.1265C15.9184 21.9002 16.7355 21.5607 17.5034 21.1179L19.6987 22.2938C19.9694 22.4365 20.3041 22.3873 20.5207 22.1708L22.1844 20.5078C22.401 20.2913 22.4502 19.9567 22.3075 19.6861L21.1163 17.4916C21.5593 16.729 21.8989 15.9122 22.1253 15.0561L24.5077 14.3377C24.803 14.2492 24.9999 13.9785 24.9999 13.6735V11.3216C25.0048 11.0165 24.803 10.7459 24.5126 10.6574ZM18.9655 12.5C18.9655 16.0708 16.0708 18.9655 12.5 18.9655C8.92919 18.9655 6.03448 16.0708 6.03448 12.5C6.03448 8.92919 8.92919 6.03448 12.5 6.03448C16.0708 6.03448 18.9655 8.92919 18.9655 12.5Z"
                fill="#FEFCF9"
              />
            </svg>
            <div className="inline-block pl-2 text-[1.1rem]">
              $GEMZ - Read Specs
            </div>
          </h6>
        </div>
        <div
          data-scroll
          data-scroll-speed="4"
          className="emporium-card relative mx-auto max-w-screen-xl grid-cols-2 justify-between gap-x-8 md:grid md:w-[60%]"
        >
          <div className="card-outer relative mb-6 md:mb-0">
            <div
              className="card-back absolute flex h-full w-full items-center justify-center rounded-3xl bg-[rgba(255,255,255,0.14)] p-10 shadow-xl dark:bg-[rgba(0,0,0,0.14)]"
              style={{
                borderColor: "rgba(254, 252, 249, 0.15)",
                borderWidth: "1px",
              }}
            >
              <svg
                viewBox="0 0 192 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="svg-logo w-[80%] opacity-40"
              >
                <path
                  d="M61.0927 17.0987L63.7512 18.3865L64.9959 30.3351L64.9605 30.4114L64.7908 30.6949C64.7283 30.8029 64.6433 30.9335 64.5448 31.0822C64.4298 31.2387 64.3066 31.3895 64.1757 31.534C64.0315 31.6968 63.8826 31.8598 63.7247 32.0273C63.5607 32.199 63.3767 32.3517 63.1763 32.4823C62.9672 32.6196 62.758 32.748 62.5439 32.8632C62.3178 32.9883 62.0772 33.0868 61.8271 33.1565C61.5611 33.2182 61.2874 33.2426 61.0143 33.229C60.3721 33.2223 59.7499 33.0131 59.2421 32.6331C58.6461 32.199 58.1402 31.6598 57.751 31.0439C57.2739 30.3007 56.8717 29.5148 56.5499 28.6971C56.1771 27.7726 55.8637 26.8267 55.6114 25.8648C55.3545 24.8811 55.1295 23.8746 54.949 22.7871C54.7685 21.6997 54.6259 20.6694 54.5299 19.6784C54.4354 18.6858 54.3799 17.7312 54.3635 16.8144C54.2272 13.8942 54.509 10.9692 55.2009 8.12284C55.8626 5.69809 56.8883 4.24917 58.278 3.77607C58.7114 3.5506 59.2177 3.49527 59.6918 3.62159C60.1411 3.73127 60.5817 3.87214 61.0101 4.0431C61.4611 4.24529 61.8675 4.52971 62.2071 4.88082C62.6145 5.28307 62.9707 5.65507 63.2712 5.99692C63.6105 6.38942 63.9135 6.81002 64.1768 7.25387C64.4847 7.7514 64.7358 8.16091 64.9256 8.48249C65.1153 8.80406 65.301 9.15687 65.4781 9.541C65.6551 9.92512 65.7701 10.1768 65.8135 10.2918C65.8616 10.4067 65.8999 10.4906 65.9284 10.5435L67.0467 3.92139L65.6864 5.00533L65.1762 4.51144C64.7098 4.07724 64.1718 3.72131 63.5844 3.45823C62.8083 3.0885 61.9994 2.78715 61.1674 2.55783C60.0942 2.3031 58.9737 2.29728 57.897 2.54086C56.5167 2.81385 55.2014 3.33583 54.0199 4.07955C52.2269 5.27156 50.745 6.85138 49.692 8.69361C48.4061 10.7516 47.6438 13.0755 47.4681 15.4735C47.2889 17.003 47.2811 18.5465 47.445 20.0771C47.5965 21.5976 47.8665 23.1048 48.2526 24.5856C48.6309 26.006 49.2322 27.3615 50.0357 28.6048C50.8076 29.8234 51.8207 30.8824 53.0167 31.7209C54.1611 32.5449 55.4291 33.1947 56.7767 33.6478C57.8892 34.0355 59.0594 34.246 60.2419 34.2712C61.2924 34.2637 62.3378 34.1267 63.3529 33.8637C64.251 33.6401 65.1225 33.3261 65.9531 32.9266C66.6506 32.5759 67.3184 32.1724 67.9505 31.72L68.0685 31.6355C68.6497 31.22 69.0522 30.9323 69.2303 30.7621C69.4202 30.5806 69.5788 30.4487 69.6831 30.3667L69.1992 19.2949L71.2663 17.3613L61.0927 17.0987Z"
                  fill="#1D1926"
                />
                <path
                  d="M24.3948 4.78106L26.331 30.3975L29.4119 31.9048L18.3164 32.8074L20.5245 31.2986L19.1933 8.38244L13.102 30.822L4.24078 10.106L5.70563 32.5702L8.1696 34.0396L1.30458 34.1316L3.88851 32.8031L2.44109 7.97922L0.0516793 6.30817L8.65099 6.1538L14.1021 20.9478L18.6476 4.11852L26.3784 3.32088L24.3948 4.78106Z"
                  fill="#1D1926"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M36.3721 7.13418L47.2917 34.6016L50.0162 36.4937L41.0085 36.8735L42.4915 35.449L39.9701 27.9663L33.6516 28.5249L31.5492 37.9737L33.8138 39.6114L26.7954 39.8709L29.6802 37.1125L36.3721 7.13418ZM33.9702 27.059L39.5124 26.55L36.241 16.7391L33.9702 27.059Z"
                  fill="#1D1926"
                />
                <path
                  d="M77.9661 9.35244L79.0961 32.5883L81.3232 34.1866L70.4496 34.6444L73.6833 32.3605L72.1628 10.4316L69.3305 8.93763L81.1133 7.88918L77.9661 9.35244Z"
                  fill="#1D1926"
                />
                <path
                  d="M94.8154 30.4862C94.1993 30.4654 93.5879 30.3748 92.9938 30.2162C91.8595 29.8833 90.932 28.8583 90.2113 27.1409C89.4489 25.2272 89.0194 23.2042 88.9402 21.1538C88.8135 18.8819 88.8479 16.604 89.0432 14.3363C89.1774 12.3304 89.6065 10.353 90.3175 8.46377C90.9749 6.82261 91.7617 5.90033 92.6779 5.69691C93.4403 5.55636 94.2277 5.62233 94.9533 5.88756C95.6336 6.12057 96.2636 6.47295 96.8117 6.92707C97.3364 7.38586 97.8082 7.89832 98.2189 8.45549C98.5378 8.85535 98.8238 9.27892 99.0741 9.72226C99.1664 9.92016 99.2728 10.1116 99.3925 10.2953L100.34 4.6423L98.7495 5.73037L98.1447 5.34502C97.6192 5.05914 97.059 4.83743 96.4771 4.68493C95.6708 4.45824 94.8484 4.2885 94.0166 4.17707C92.9548 4.06702 91.8808 4.15429 90.8523 4.4342C89.5923 4.75463 88.4 5.28685 87.3299 6.00659C85.5115 7.19373 84.1646 9.02682 83.2893 11.5059C81.6079 16.3358 81.915 21.6052 84.1467 26.217C85.2356 28.4619 86.6552 29.9946 88.4053 30.8149C89.7385 31.4241 91.158 31.8382 92.6173 32.0437C93.8202 32.2348 95.0441 32.2712 96.2572 32.152C97.2536 32.0267 98.2364 31.8154 99.194 31.5205C99.842 31.3369 100.477 31.1128 101.095 30.8498C101.339 30.7358 101.574 30.6036 101.796 30.4544L100.796 25.9404C100.781 25.9697 100.765 26.0083 100.748 26.0518C100.733 26.0882 100.717 26.1283 100.699 26.1692C100.681 26.2083 100.657 26.2652 100.626 26.3389C100.586 26.4344 100.534 26.5581 100.469 26.7075C100.357 26.964 100.228 27.2131 100.082 27.4534C99.9026 27.7443 99.7049 28.0244 99.4902 28.2921C99.2501 28.5993 98.9812 28.8843 98.6868 29.1435C98.3647 29.4082 98.016 29.6412 97.6461 29.8388C97.24 30.0535 96.8092 30.2211 96.3627 30.3382C95.8568 30.4593 95.3357 30.5091 94.8154 30.4862Z"
                  fill="#1D1926"
                />
                <path
                  d="M111.608 9.49539L109.05 8.65096L128.596 6.55499L128.805 12.8283L125.991 8.26671L117.473 8.99836L118.684 22.4299L124.529 22.1558L125.737 20.2599L125.74 25.5575L124.82 23.4995L118.807 23.6342L120.013 37.0258L122.895 37.9623L111.831 39.3273L114.545 36.7722L111.608 9.49539Z"
                  fill="#1D1926"
                />
                <path
                  d="M167.714 28.2381L166.676 31.6401L159.686 32.1974L159.871 8.68866L162.197 7.03537L150.849 7.23906L153.385 8.37326L154.261 31.5069L152.548 33.1892L168.258 32.9072L167.714 28.2381Z"
                  fill="#1D1926"
                />
                <path
                  d="M179.15 17.0318L188.418 32.9809L191.665 34.5342L181.332 36.8966L182.958 34.7083L176.323 20.2255L175.169 21.5061L175.682 34.1889L178.309 35.7934L168.62 36.6351L170.438 35.4227L169.495 8.76133L168.051 7.45172L175.682 7.23906L174.04 8.56399L175.095 18.9521L184.019 6.69318L183.259 5.09528L190.532 6.28635L187.058 7.23906L179.15 17.0318Z"
                  fill="#1D1926"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M143.277 10.8609C142.311 10.4008 141.248 10.1811 140.087 10.2019C138.753 10.2259 137.554 10.5143 136.49 11.067C135.455 11.6193 134.612 12.3366 133.961 13.219C133.308 14.0734 132.761 15.1084 132.319 16.3241C131.876 17.5399 131.564 18.7392 131.382 19.9222C131.2 21.1051 131.092 22.371 131.059 23.7199C131.017 24.6194 131.048 25.5317 131.151 26.4568C131.254 27.3537 131.416 28.2497 131.635 29.1446C131.883 30.0389 132.188 30.8901 132.551 31.6982C132.914 32.5062 133.362 33.2425 133.897 33.907C134.431 34.5715 135.022 35.1508 135.669 35.6447C136.316 36.1106 137.062 36.4624 137.908 36.7C138.753 36.9095 139.639 36.9779 140.567 36.905C141.871 36.7974 143.024 36.3975 144.027 35.7054C145.06 35.0127 145.871 34.1696 146.463 33.1759C147.083 32.1536 147.585 30.9929 147.967 29.694C148.35 28.367 148.603 27.0985 148.726 25.8885C148.878 24.6499 148.942 23.3848 148.919 22.0932C148.898 20.9138 148.761 19.7507 148.508 18.6036C148.285 17.456 147.931 16.3669 147.449 15.3363C146.995 14.3052 146.428 13.4166 145.747 12.6704C145.065 11.8962 144.242 11.293 143.277 10.8609ZM143.555 19.1138C143.727 20.5713 143.811 22.0304 143.808 23.491C143.778 25.0645 143.703 26.5264 143.582 27.8768C143.461 29.2272 143.267 30.5368 143 31.8055C142.761 33.0457 142.387 34.0355 141.878 34.7749C141.369 35.5143 140.752 35.8906 140.026 35.9036C139.243 35.9176 138.551 35.3683 137.951 34.2556C137.351 33.1428 136.905 31.7745 136.615 30.1506C136.353 28.4981 136.205 26.7312 136.172 24.8499C136.134 22.7721 136.186 20.819 136.328 18.9908C136.497 17.1339 136.859 15.4281 137.411 13.8733C137.963 12.2905 138.687 11.4208 139.584 11.2643C140.279 11.1675 140.908 11.4793 141.473 12.1994C142.036 12.8915 142.474 13.8527 142.787 15.0829C143.128 16.3127 143.384 17.6563 143.555 19.1138Z"
                  fill="#1D1926"
                />
              </svg>
            </div>
            <div
              className="card-front relative rounded-3xl bg-[rgba(255,255,255,0.14)] p-10 shadow-xl dark:bg-[rgba(0,0,0,0.14)]"
              style={{
                borderColor: "rgba(254, 252, 249, 0.15)",
                borderWidth: "1px",
              }}
            >
              <img src="/store-gems.webp" alt="" className="block w-24 pb-16" />
              <h3
                className="
                    text-subhead 
                    block 
                    pb-6
                    font-display"
              >
                Powered By $GEMZ
              </h3>
              <div
                className="
                    text-p
                    mx-auto
                    block
                    opacity-70"
              >
                <p className="pb-16">
                  $GEMZ are the token of our ecosystem. Earn $GEMZ by staking
                  your Magic Folk NFT. The rarer the NFT, the more $GEMZ you
                  earn. Burn $GEMZ to acquire limited items and more.
                </p>

                <p className="absolute bottom-0 left-0 ml-10 w-full pb-12 italic text-gray-400">
                  Staking available at launch.
                </p>
              </div>
            </div>
          </div>

          <div className="card-outer relative mb-6 md:mb-0">
            <div
              className="card-back absolute flex h-full w-full items-center justify-center rounded-3xl bg-[rgba(255,255,255,0.14)] p-10 shadow-xl dark:bg-[rgba(0,0,0,0.14)]"
              style={{
                borderColor: "rgba(254, 252, 249, 0.15)",
                borderWidth: "1px",
              }}
            >
              <svg
                viewBox="0 0 192 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="svg-logo w-[80%] opacity-40"
              >
                <path
                  d="M61.0927 17.0987L63.7512 18.3865L64.9959 30.3351L64.9605 30.4114L64.7908 30.6949C64.7283 30.8029 64.6433 30.9335 64.5448 31.0822C64.4298 31.2387 64.3066 31.3895 64.1757 31.534C64.0315 31.6968 63.8826 31.8598 63.7247 32.0273C63.5607 32.199 63.3767 32.3517 63.1763 32.4823C62.9672 32.6196 62.758 32.748 62.5439 32.8632C62.3178 32.9883 62.0772 33.0868 61.8271 33.1565C61.5611 33.2182 61.2874 33.2426 61.0143 33.229C60.3721 33.2223 59.7499 33.0131 59.2421 32.6331C58.6461 32.199 58.1402 31.6598 57.751 31.0439C57.2739 30.3007 56.8717 29.5148 56.5499 28.6971C56.1771 27.7726 55.8637 26.8267 55.6114 25.8648C55.3545 24.8811 55.1295 23.8746 54.949 22.7871C54.7685 21.6997 54.6259 20.6694 54.5299 19.6784C54.4354 18.6858 54.3799 17.7312 54.3635 16.8144C54.2272 13.8942 54.509 10.9692 55.2009 8.12284C55.8626 5.69809 56.8883 4.24917 58.278 3.77607C58.7114 3.5506 59.2177 3.49527 59.6918 3.62159C60.1411 3.73127 60.5817 3.87214 61.0101 4.0431C61.4611 4.24529 61.8675 4.52971 62.2071 4.88082C62.6145 5.28307 62.9707 5.65507 63.2712 5.99692C63.6105 6.38942 63.9135 6.81002 64.1768 7.25387C64.4847 7.7514 64.7358 8.16091 64.9256 8.48249C65.1153 8.80406 65.301 9.15687 65.4781 9.541C65.6551 9.92512 65.7701 10.1768 65.8135 10.2918C65.8616 10.4067 65.8999 10.4906 65.9284 10.5435L67.0467 3.92139L65.6864 5.00533L65.1762 4.51144C64.7098 4.07724 64.1718 3.72131 63.5844 3.45823C62.8083 3.0885 61.9994 2.78715 61.1674 2.55783C60.0942 2.3031 58.9737 2.29728 57.897 2.54086C56.5167 2.81385 55.2014 3.33583 54.0199 4.07955C52.2269 5.27156 50.745 6.85138 49.692 8.69361C48.4061 10.7516 47.6438 13.0755 47.4681 15.4735C47.2889 17.003 47.2811 18.5465 47.445 20.0771C47.5965 21.5976 47.8665 23.1048 48.2526 24.5856C48.6309 26.006 49.2322 27.3615 50.0357 28.6048C50.8076 29.8234 51.8207 30.8824 53.0167 31.7209C54.1611 32.5449 55.4291 33.1947 56.7767 33.6478C57.8892 34.0355 59.0594 34.246 60.2419 34.2712C61.2924 34.2637 62.3378 34.1267 63.3529 33.8637C64.251 33.6401 65.1225 33.3261 65.9531 32.9266C66.6506 32.5759 67.3184 32.1724 67.9505 31.72L68.0685 31.6355C68.6497 31.22 69.0522 30.9323 69.2303 30.7621C69.4202 30.5806 69.5788 30.4487 69.6831 30.3667L69.1992 19.2949L71.2663 17.3613L61.0927 17.0987Z"
                  fill="#1D1926"
                />
                <path
                  d="M24.3948 4.78106L26.331 30.3975L29.4119 31.9048L18.3164 32.8074L20.5245 31.2986L19.1933 8.38244L13.102 30.822L4.24078 10.106L5.70563 32.5702L8.1696 34.0396L1.30458 34.1316L3.88851 32.8031L2.44109 7.97922L0.0516793 6.30817L8.65099 6.1538L14.1021 20.9478L18.6476 4.11852L26.3784 3.32088L24.3948 4.78106Z"
                  fill="#1D1926"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M36.3721 7.13418L47.2917 34.6016L50.0162 36.4937L41.0085 36.8735L42.4915 35.449L39.9701 27.9663L33.6516 28.5249L31.5492 37.9737L33.8138 39.6114L26.7954 39.8709L29.6802 37.1125L36.3721 7.13418ZM33.9702 27.059L39.5124 26.55L36.241 16.7391L33.9702 27.059Z"
                  fill="#1D1926"
                />
                <path
                  d="M77.9661 9.35244L79.0961 32.5883L81.3232 34.1866L70.4496 34.6444L73.6833 32.3605L72.1628 10.4316L69.3305 8.93763L81.1133 7.88918L77.9661 9.35244Z"
                  fill="#1D1926"
                />
                <path
                  d="M94.8154 30.4862C94.1993 30.4654 93.5879 30.3748 92.9938 30.2162C91.8595 29.8833 90.932 28.8583 90.2113 27.1409C89.4489 25.2272 89.0194 23.2042 88.9402 21.1538C88.8135 18.8819 88.8479 16.604 89.0432 14.3363C89.1774 12.3304 89.6065 10.353 90.3175 8.46377C90.9749 6.82261 91.7617 5.90033 92.6779 5.69691C93.4403 5.55636 94.2277 5.62233 94.9533 5.88756C95.6336 6.12057 96.2636 6.47295 96.8117 6.92707C97.3364 7.38586 97.8082 7.89832 98.2189 8.45549C98.5378 8.85535 98.8238 9.27892 99.0741 9.72226C99.1664 9.92016 99.2728 10.1116 99.3925 10.2953L100.34 4.6423L98.7495 5.73037L98.1447 5.34502C97.6192 5.05914 97.059 4.83743 96.4771 4.68493C95.6708 4.45824 94.8484 4.2885 94.0166 4.17707C92.9548 4.06702 91.8808 4.15429 90.8523 4.4342C89.5923 4.75463 88.4 5.28685 87.3299 6.00659C85.5115 7.19373 84.1646 9.02682 83.2893 11.5059C81.6079 16.3358 81.915 21.6052 84.1467 26.217C85.2356 28.4619 86.6552 29.9946 88.4053 30.8149C89.7385 31.4241 91.158 31.8382 92.6173 32.0437C93.8202 32.2348 95.0441 32.2712 96.2572 32.152C97.2536 32.0267 98.2364 31.8154 99.194 31.5205C99.842 31.3369 100.477 31.1128 101.095 30.8498C101.339 30.7358 101.574 30.6036 101.796 30.4544L100.796 25.9404C100.781 25.9697 100.765 26.0083 100.748 26.0518C100.733 26.0882 100.717 26.1283 100.699 26.1692C100.681 26.2083 100.657 26.2652 100.626 26.3389C100.586 26.4344 100.534 26.5581 100.469 26.7075C100.357 26.964 100.228 27.2131 100.082 27.4534C99.9026 27.7443 99.7049 28.0244 99.4902 28.2921C99.2501 28.5993 98.9812 28.8843 98.6868 29.1435C98.3647 29.4082 98.016 29.6412 97.6461 29.8388C97.24 30.0535 96.8092 30.2211 96.3627 30.3382C95.8568 30.4593 95.3357 30.5091 94.8154 30.4862Z"
                  fill="#1D1926"
                />
                <path
                  d="M111.608 9.49539L109.05 8.65096L128.596 6.55499L128.805 12.8283L125.991 8.26671L117.473 8.99836L118.684 22.4299L124.529 22.1558L125.737 20.2599L125.74 25.5575L124.82 23.4995L118.807 23.6342L120.013 37.0258L122.895 37.9623L111.831 39.3273L114.545 36.7722L111.608 9.49539Z"
                  fill="#1D1926"
                />
                <path
                  d="M167.714 28.2381L166.676 31.6401L159.686 32.1974L159.871 8.68866L162.197 7.03537L150.849 7.23906L153.385 8.37326L154.261 31.5069L152.548 33.1892L168.258 32.9072L167.714 28.2381Z"
                  fill="#1D1926"
                />
                <path
                  d="M179.15 17.0318L188.418 32.9809L191.665 34.5342L181.332 36.8966L182.958 34.7083L176.323 20.2255L175.169 21.5061L175.682 34.1889L178.309 35.7934L168.62 36.6351L170.438 35.4227L169.495 8.76133L168.051 7.45172L175.682 7.23906L174.04 8.56399L175.095 18.9521L184.019 6.69318L183.259 5.09528L190.532 6.28635L187.058 7.23906L179.15 17.0318Z"
                  fill="#1D1926"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M143.277 10.8609C142.311 10.4008 141.248 10.1811 140.087 10.2019C138.753 10.2259 137.554 10.5143 136.49 11.067C135.455 11.6193 134.612 12.3366 133.961 13.219C133.308 14.0734 132.761 15.1084 132.319 16.3241C131.876 17.5399 131.564 18.7392 131.382 19.9222C131.2 21.1051 131.092 22.371 131.059 23.7199C131.017 24.6194 131.048 25.5317 131.151 26.4568C131.254 27.3537 131.416 28.2497 131.635 29.1446C131.883 30.0389 132.188 30.8901 132.551 31.6982C132.914 32.5062 133.362 33.2425 133.897 33.907C134.431 34.5715 135.022 35.1508 135.669 35.6447C136.316 36.1106 137.062 36.4624 137.908 36.7C138.753 36.9095 139.639 36.9779 140.567 36.905C141.871 36.7974 143.024 36.3975 144.027 35.7054C145.06 35.0127 145.871 34.1696 146.463 33.1759C147.083 32.1536 147.585 30.9929 147.967 29.694C148.35 28.367 148.603 27.0985 148.726 25.8885C148.878 24.6499 148.942 23.3848 148.919 22.0932C148.898 20.9138 148.761 19.7507 148.508 18.6036C148.285 17.456 147.931 16.3669 147.449 15.3363C146.995 14.3052 146.428 13.4166 145.747 12.6704C145.065 11.8962 144.242 11.293 143.277 10.8609ZM143.555 19.1138C143.727 20.5713 143.811 22.0304 143.808 23.491C143.778 25.0645 143.703 26.5264 143.582 27.8768C143.461 29.2272 143.267 30.5368 143 31.8055C142.761 33.0457 142.387 34.0355 141.878 34.7749C141.369 35.5143 140.752 35.8906 140.026 35.9036C139.243 35.9176 138.551 35.3683 137.951 34.2556C137.351 33.1428 136.905 31.7745 136.615 30.1506C136.353 28.4981 136.205 26.7312 136.172 24.8499C136.134 22.7721 136.186 20.819 136.328 18.9908C136.497 17.1339 136.859 15.4281 137.411 13.8733C137.963 12.2905 138.687 11.4208 139.584 11.2643C140.279 11.1675 140.908 11.4793 141.473 12.1994C142.036 12.8915 142.474 13.8527 142.787 15.0829C143.128 16.3127 143.384 17.6563 143.555 19.1138Z"
                  fill="#1D1926"
                />
              </svg>
            </div>
            <div
              className="card-front relative rounded-3xl bg-[rgba(255,255,255,0.14)] p-10 shadow-xl dark:bg-[rgba(0,0,0,0.14)]"
              style={{
                borderColor: "rgba(254, 252, 249, 0.15)",
                borderWidth: "1px",
              }}
            >
              <img
                src="/store-power.webp"
                alt=""
                className="block w-24 pb-16"
              />
              <h3
                className="
                text-subhead 
                block 
                pb-6
                font-display"
              >
                Rarity is Power
              </h3>
              <div
                className="
                  text-p
                  mx-auto
                  block
                  opacity-70"
              >
                <p className="pb-16">
                  Power represents the rate of receiving $GEMZ. The combined
                  rarity of your Magic Folk and equipped items increase your
                  Power.
                  <br />
                  <br />{" "}
                </p>
                <p className="absolute bottom-0 left-0 ml-10 w-full pb-12 italic text-gray-400">
                  More power. More $GEMZ.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

HomeMarketplace.propTypes = {}

export default HomeMarketplace
